var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", { attrs: { title: _vm.title } }, [
    _c("div", { staticClass: "mb-4" }, [
      _c(
        "label",
        {
          staticClass: "block text-sm font-medium text-gray-700 mb-1",
          attrs: { for: "month-select" }
        },
        [_vm._v("Select Month")]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.selectedMonth,
            expression: "selectedMonth"
          }
        ],
        staticClass: "border border-gray-300 rounded px-3 py-2 w-full max-w-xs",
        attrs: { id: "month-select", type: "month" },
        domProps: { value: _vm.selectedMonth },
        on: {
          change: _vm.fetchSummary,
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.selectedMonth = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c("div", { staticClass: "text-gray-500" }, [
          _vm._v("Loading ZenDesk Summary...")
        ])
      : _c(
          "div",
          [
            _c("p", { staticClass: "mb-4 text-gray-700" }, [
              _vm.summary.length
                ? _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.summary.length) +
                        " contracts summarized. Most tickets:\n        " +
                        _vm._s(
                          _vm.summary.reduce(function(max, row) {
                            return row.total > max.total ? row : max
                          }, _vm.summary[0]).contract
                        ) +
                        ".\n      "
                    )
                  ])
                : _c("span", [_vm._v("No summary data found for this month.")])
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                staticClass: "mb-4 text-sm text-gray-800 list-disc list-inside"
              },
              [
                _c("li", [
                  _vm._v("Total Tickets: " + _vm._s(_vm.summaryStats.total))
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("New: " + _vm._s(_vm.summaryStats.new))]),
                _vm._v(" "),
                _c("li", [_vm._v("Open: " + _vm._s(_vm.summaryStats.open))]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Pending: " + _vm._s(_vm.summaryStats.pending))
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Hold: " + _vm._s(_vm.summaryStats.hold))]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Solved: " + _vm._s(_vm.summaryStats.solved))
                ]),
                _vm._v(" "),
                _c("li", [_vm._v("Closed: " + _vm._s(_vm.summaryStats.closed))])
              ]
            ),
            _vm._v(" "),
            _c(
              "router-link",
              {
                staticClass:
                  "inline-flex items-center px-5 py-3 bg-white text-indigo-600 font-semibold border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 transition duration-200",
                attrs: { to: "/" + _vm.id + "/ZendeskSummary" }
              },
              [
                _vm._v("\n      View Detailed Zendesk Reports\n      "),
                _c(
                  "svg",
                  {
                    staticClass: "ml-2 h-4 w-4",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      fill: "none",
                      viewBox: "0 0 24 24",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }
                  },
                  [_c("path", { attrs: { d: "M5 12h14M12 5l7 7-7 7" } })]
                )
              ]
            )
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0b1d9de0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1d9de0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cards/InfoCards/ZendeskSummaryCard.vue
// module id = null
// module chunks = 